<template>
    <main id="content" class="feedback-content">
        <div class="container">
            <div class="relative-section">
                <div class="brecrump font-bai">
                    <router-link to="/">{{ $t("app.Home") }}</router-link> /
                    <b> {{ $t("app.Filing of notice") }}</b>
                </div>
            </div>
            <img
                src="../assets/images/feedback2.png"
                alt
                class="feature-feedback"
            />
            <h3 class="text-center title-form-feedback font-balo">
                {{ $t("app.Filing of notice") }}
            </h3>
            <div class="form-feedback">
                <ValidationObserver v-slot="{ handleSubmit, reset }" ref="form">
                    <form
                        @submit.prevent="handleSubmit(onSubmit)"
                        @reset.prevent="reset"
                    >
                        <fa-rating
                            :glyph="star"
                            :spacing="5"
                            :inactive-color="'#fff'"
                            :active-color="'#FBB13C'"
                            :border-color="'#FBB13C'"
                            :border-width="3"
                            :increment="1"
                            :fixed-points="2"
                            :rating="feedback_number"
                            :item-size="30"
                            :show-rating="false"
                        >
                        </fa-rating>

                        <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <input
                                class="ip-feedback"
                                type="text"
                                :placeholder="$t('app.Enter name')"
                                name="name"
                                v-model="feedback_name"
                                :class="{ 'is-invalid': errors[0] }"
                            />
                        </validation-provider>
                        <!-- <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <input
                                class="ip-feedback"
                                type="text"
                                :placeholder="$t('app.Enter title')"
                                name="feedback_title"
                                v-model="feedback_title"
                                :class="{ 'is-invalid': errors[0] }"
                            />
                        </validation-provider> -->
                        <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <textarea
                                class="textarea-feedback"
                                name="ms-feedback"
                                :placeholder="$t('app.Enter feedback')"
                                v-model="feedback_content"
                                :class="{ 'is-invalid': errors[0] }"
                            ></textarea>
                        </validation-provider>
                        <button type="submit" class="btn-send-feedback">
                            {{$t(`app.Send`)}}
                        </button>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </main>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapActions } from "vuex";
import { pick, get, first } from "lodash";
import { FaRating } from "vue-rate-it";
import Star from "vue-rate-it/glyphs/star";
export default {
    name: "FeedbackPage",
    components: {
        ValidationProvider,
        ValidationObserver,
        FaRating
    },
    created() {
        this.star = Star;
    },
    data() {
        const _this = this;
        const referenceId = get(this.$route, 'params.reference_id', '');
        const reservationGroupId = get(this.$route, 'params.reservation_id', '');
        _this.getReservationGroup({
            ReservationGroupId: reservationGroupId
        }).then(response => {
            const reservation = first(response.Reservations)
            if(get(reservation, 'RoomCategoryId') !== referenceId) _this.$router.push('/');
            _this.checkFeedback({
                feedback_action: 'check',
                feedback_reference: referenceId,
                feedback_reservation: reservationGroupId
            }).then(checkResponse => {
                if(checkResponse) _this.$router.push('/');
            }).catch(() => {
                _this.$router.push('/');
            });
        }).catch(() => {
            _this.$router.push('/');
        });
        return {
            star: "",
            feedback_name: "",
            // feedback_title: "",
            feedback_content: "",
            feedback_number: 5,
            feedback_reference: referenceId,
            feedback_reservation: reservationGroupId,
            reference_id: referenceId,
            reservation_id: reservationGroupId,

        };
    },
    methods: {
        ...mapActions("app", ["sendFeedback", "checkFeedback"]),
        ...mapActions('hotels', ['getReservationGroup']),
        onSubmit() {
            this.sendFeedback({
                ...pick(this, [
                    "feedback_name",
                    // "feedback_title",
                    "feedback_content",
                    "feedback_number",
                    "feedback_reference",
                    "feedback_reservation"
                ])
            }).then(() => {
                this.$bvToast.toast(
                    this.$i18n.t("app.Thank your for feedback"),
                    {
                        title: this.$i18n.t("app.Successfully"),
                        variant: "success",
                        solid: true
                    }
                );
                this.clearForm();
                setTimeout(() => {
                    this.$router.push(`/`);
                }, 1000)
            });
        },
        clearForm() {
            this.feedback_name = "";
            // this.feedback_title = "";
            this.feedback_content = "";
            this.feedback_number = 5;
            this.$refs.form.reset();
        }
    }
};
</script>
